import { AlertSeverity, AlertStatus, AlertType, ResolvedStatus } from "./alerts-enums";
import { Guid } from "../../shared/utils/guid.helper";

export class AlertRecord {
  id: string;
  entityId: string | null;
  individualId: string | null;
  entityName?: string;
  status: AlertStatus | undefined;
  resolvedStatus: ResolvedStatus | undefined;
  type: AlertType | undefined;
  severity: AlertSeverity | undefined;
  createdOn: Date;
  isRead: boolean;
  modelDetailTitle: string;
  postponedTill?: Date;
  needAttention: boolean;

  constructor(data?: Partial<AlertRecord>) {
    this.id = data?.id ?? Guid.EmptyGuid;
    this.entityId = data?.entityId ?? null;
    this.individualId = data?.individualId ?? null;
    this.entityName = data?.entityName;
    this.status = data?.status;
    this.resolvedStatus = data?.resolvedStatus;
    this.type = data?.type;
    this.severity = data?.severity;
    this.createdOn = data?.createdOn ?? new Date();
    this.isRead = data?.isRead ?? false;
    this.modelDetailTitle = data?.modelDetailTitle ?? '';
    this.postponedTill = data?.postponedTill;
    this.needAttention = data?.needAttention ?? false;
  }
}
